export const searchBar = (data = [], searchInput = "") => {
  return data.filter(row => Object.values(row).some(field => 
          field && field.toString().toLowerCase().includes(searchInput.toLowerCase() )))
}